// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__JguqN","icon":"SortAdornment_icon__hzLOE","up":"SortAdornment_up__2cSHe","down":"SortAdornment_down__3CjKx","active":"SortAdornment_active__3Vu32"};